import { createSlice } from '@reduxjs/toolkit';

const initialState = {};

const rootSlice = createSlice({
  name: 'root',
  initialState,
  reducers: {
    resetAllState: () => initialState,
  },
});

export const { resetAllState } = rootSlice.actions;
export default rootSlice.reducer;